import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue"
import SearchInput from "@/components/widgets/common/SearchInput.vue"
import {
  MissionStaffingPositionBasicFragmentFragment,
  ConsultantOpenOpportunitiesQuery,
  ConsultantOpenOpportunitiesQueryQuery,
  ConsultantOpenOpportunitiesQueryQueryVariables,
  SortDirection,
  OpenMissionStaffingPositionsFilter,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import OpportunitiesOverview from "./OpportunitiesOverview.vue"
import RecordOverview from "./RecordOverview.vue"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import { useUtilities } from "@/hooks/useUtilities"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'OpportunitiesTab',
  setup(__props) {

const filters = ref<OpenMissionStaffingPositionsFilter>({})
const searchInput = ref("")

const { debounceCall } = useUtilities()
const { t } = useTranslation("Consultant/Opportunities")

const debounceSearch = debounceCall(() => {
  filters.value = {
    ...filters.value,
    search: searchInput.value || undefined,
  }
}, 700)

watch(searchInput, () => {
  if (!searchInput.value) {
    filters.value = {
      ...filters.value,
      search: undefined,
    }
  } else {
    debounceSearch()
  }
})

const pageState = ref(PageState.Loading)
const selectedOpportunity = ref<MissionStaffingPositionBasicFragmentFragment | null>(null)

const pagination = ref({
  page: 1,
  per: 10,
  length: 1,
})

const { handlePageErrorState } = usePageState(pageState)

const { loading, result, onError, onResult } = useQuery<
  ConsultantOpenOpportunitiesQueryQuery,
  ConsultantOpenOpportunitiesQueryQueryVariables
>(
  ConsultantOpenOpportunitiesQuery,
  computed(() => ({
    filter: {
      ...filters.value,
    },
    paginate: {
      per: pagination.value.per,
      page: pagination.value.page,
    },
    sort: {
      createdAt: SortDirection.Asc,
    },
  }))
)

const refetchQueries = computed(() => {
  return [
    {
      query: ConsultantOpenOpportunitiesQuery,
      variables: {
        filter: filters.value,
        paginate: {
          per: pagination.value.per,
          page: pagination.value.page,
        },
        sort: {
          createdAt: SortDirection.Asc,
        },
      },
    },
  ]
})

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  pagination.value.length = result?.data?.openMissionStaffingPositions?.pagination?.pageCount || 0

  if (result?.data?.openMissionStaffingPositions.data.length) {
    selectedOpportunity.value = result.data.openMissionStaffingPositions.data[0]
    return
  }
  selectedOpportunity.value = null
})

const onOpportunityClick = (opportunity: MissionStaffingPositionBasicFragmentFragment) => {
  selectedOpportunity.value = opportunity
  window.scrollTo(0, 0)
}

const onResetFilters = () => {
  filters.value = {}
}

const isSearchEmpty = computed(() => {
  return !searchInput.value
})

const getOpportunitiesMessage = computed(() => {
  return isSearchEmpty.value
    ? t("noOpportunitiesMessage.noOpportunities")
    : t("noOpportunitiesMessage.noOpportunitiesFoundSearch", {
        searchInput: searchInput.value,
      })
})

return { __sfc: true,filters, searchInput, debounceCall, t, debounceSearch, pageState, selectedOpportunity, pagination, handlePageErrorState, loading, result, onError, onResult, refetchQueries, onOpportunityClick, onResetFilters, isSearchEmpty, getOpportunitiesMessage, SearchInput, OpportunitiesOverview, RecordOverview, PageState, PageStateError }
}

})